"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSettingsComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const platform_browser_1 = require("@angular/platform-browser");
//INTERNAL BITS
const user_service_1 = require("./user.service");
const permission_service_1 = require("./permission.service");
const branding_service_1 = require("./branding.service");
let UserSettingsComponent = class UserSettingsComponent {
    constructor(_permission, _user, _title, _branding) {
        this._permission = _permission;
        this._user = _user;
        this._title = _title;
        this._branding = _branding;
        this.tabsetOpen = {
            timezone: false,
            passwordReset: false,
            changeEmail: false
            //..other tabs
        };
        this.passwordReset = { internal: true };
        this._title.setTitle(this._branding.getProductSuiteTitle());
    }
    ngOnInit() {
        this.permission = this._permission.get();
        //For now timezone, will be default tab
        if (this._user.getUserTab()) {
            this.tabsetOpen[this._user.getUserTab()] = true;
        }
    }
    openTab(tab) {
        Object.keys(this.tabsetOpen).forEach(key => {
            if (this.tabsetOpen[key]) {
                this._user.setUserTab(key);
            }
        });
    }
};
exports.UserSettingsComponent = UserSettingsComponent;
exports.UserSettingsComponent = UserSettingsComponent = __decorate([
    (0, core_1.Component)({
        selector: 'user-settings',
        templateUrl: 'app/user-settings.component.html',
        styleUrls: ['styles/user-settings.component.css']
    }),
    __metadata("design:paramtypes", [permission_service_1.PermissionService,
        user_service_1.UserService,
        platform_browser_1.Title,
        branding_service_1.BrandingService])
], UserSettingsComponent);
//# sourceMappingURL=user-settings.component.js.map